import Group from './Group';
import withStyles from 'react-jss';
import styles from './styles';
export default withStyles(styles)(Group);



//////////////////
// WEBPACK FOOTER
// ./src/components/Group/index.tsx
// module id = 1351
// module chunks = 0